"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiPaginatedResultAdapter = void 0;
var core_1 = require("@moralisweb3/core");
var ApiResultAdapter_1 = require("./ApiResultAdapter");
/**
 * The adapter for a paginated API result.
 */
var ApiPaginatedResultAdapter = /** @class */ (function (_super) {
    __extends(ApiPaginatedResultAdapter, _super);
    function ApiPaginatedResultAdapter(data, adapter, jsonAdapter, params, nextHandler) {
        var _this = _super.call(this, data, adapter, jsonAdapter, params) || this;
        _this.nextHandler = nextHandler;
        /**
         * Checks an existence of the next page.
         *
         * @returns `true` if a next page exists, otherwise `false`.
         */
        _this.hasNext = function () {
            return !!_this.nextHandler;
        };
        /**
         * Gets a next page of the paginated result.
         *
         * @returns a new instance of a paginated adapter.
         */
        _this.next = function () {
            if (!_this.nextHandler) {
                throw new core_1.MoralisApiError({
                    code: core_1.ApiErrorCode.PAGE_LIMIT_EXCEEDED,
                    message: 'Page limit exceeded! Before call this method check an existence of the next page by .hasNext() method.',
                });
            }
            return _this.nextHandler();
        };
        return _this;
    }
    Object.defineProperty(ApiPaginatedResultAdapter.prototype, "pagination", {
        /**
         * @returns an info about pagination.
         */
        get: function () {
            return {
                total: this.data.total,
                page: this.data.page,
                pageSize: this.data.page_size,
                cursor: this.data.cursor,
            };
        },
        enumerable: false,
        configurable: true
    });
    return ApiPaginatedResultAdapter;
}(ApiResultAdapter_1.ApiResultAdapter));
exports.ApiPaginatedResultAdapter = ApiPaginatedResultAdapter;
//# sourceMappingURL=ApiPaginatedResultAdapter.js.map